import {
  ajax,
  ajaxErrorAlert,
  ajaxPost,
  parceAjaxErrorResponse,
} from "../utils";
// dropzone events https://github.com/dropzone/dropzone/blob/main/src/options.js
import { ErrorSwal, SuccessSwal, SwalPost } from "../../app";
import { bsModal } from "../plugins";

const { Dropzone } = require("dropzone");

$(function () {
  const body = $("body");

  if (body.hasClass("video-list")) {
    const table = $(".table");
    const form = $(".listFilterForm");
    const selectAll = $(".select-all-videos");

    table.DataTable({
      columns: [
        {
          data: null,
          defaultContent: "",
          className: "dtr-control position-relative pe-0",
          orderable: false,
          searchable: false,
        },
        {
          data: "checkbox",
          render: function (data, type, row) {
            return `
              <div class="form-check">
                <input class="form-check-input" type="checkbox" name="videos" value="${row.id}" id="video_${row.id}">
                <label class="form-check-label position-absolute top-0 bottom-0 start-0 end-0 h-100 w-100" for="video_${row.id}"></label>
              </div>`;
          },
        },
        { data: "video_id" },
        { data: "thumbnail" },
        { data: "title" },
        { data: "mbps" },
        { data: "teacher" },
        { data: "is_active" },
        { data: "actions" },
      ],
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
      fnDrawCallback: function (oSettings) {
        selectAll.prop("checked", false).prop("indeterminate", false);
        triggerBulkAction();
      },
      rowCallback: function (nRow, aData) {
        if ($(this).find("th[data-column=actions]").length > 0) {
          const rowActions = `<div class="btn-group" role="group">
            <button type="button" class="rowActionMenuBtn btn btn-primary dropdown-toggle me-2" data-bs-toggle="dropdown" aria-expanded="false">
              <span class="d-none d-sm-inline-block">Əməliyyat</span>
              <span class="inline-block d-sm-none"><i class="fas fa-ellipsis-v"></i></span>
            </button>
            <ul class="rowActionMenu dropdown-menu rounded-1 shadow">
              <div class="d-flex justify-content-center align-items-center p-2">
                <div class="spinner-border text-secondary" role="status" style="border-width: 1px"></div>
              </div>
            </ul>
            <button data-video-id="${aData["id"]}" class="reRenderModalBtn btn btn-kms-gradient d-none d-md-inline-block rounded-start rounded-end me-2">
              <i class="fas fa-spinner"></i>
            </button>
            <button data-video-id="${aData["id"]}" class="deleteVideo d-none d-md-inline-block btn btn-danger rounded-start rounded-end">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>`;
          $(nRow).find("td:last-of-type").append(rowActions);
        }
        if ("id" in aData) {
          $(nRow).attr("id", aData["id"]);
        }
        if ("table_row_class" in aData) {
          $(nRow).addClass(aData["table_row_class"]);
        }
      },
    });

    $(document).on("click", ".rowActionMenuBtn", (e) => {
      const btn = $(e.currentTarget);
      const rowId = btn.closest("tr").attr("id");
      const menu = btn.parent().find(".rowActionMenu");

      ajaxPost(rowId + "/action-buttons/", {}, btn).then((response) => {
        menu.html(String(response["html"]));
      });
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
      $(body).modal("hideAll");
    });

    selectAll.on("change", (e) => {
      const checkboxes = $("input[name=videos]");
      if (e.target.checked) {
        checkboxes.prop("checked", true);
      } else {
        checkboxes.prop("checked", false);
      }
      triggerBulkAction();
    });

    $(document).on("change", "input[name=videos]", (e) => {
      const checkboxes = $("input[name=videos]");
      const checked = checkboxes.filter(":checked").length;
      const total = checkboxes.length;

      if (checked === 0) {
        selectAll.prop("checked", false).prop("indeterminate", false);
      } else if (checked === total) {
        selectAll.prop("checked", true).prop("indeterminate", false);
      } else {
        selectAll.prop("checked", false).prop("indeterminate", true);
      }
      triggerBulkAction();
    });

    const triggerBulkAction = () => {
      const bulkActionButtons = $(".bulk-video-actions");
      const checkboxes = $("input[name=videos]");
      const checked = checkboxes.filter(":checked").length;

      $("#selectedVideoCount").text(checked);

      if (checked > 0) {
        bulkActionButtons.addClass("show");
      } else {
        bulkActionButtons.removeClass("show");
      }
    };

    $(document).on("click", ".bulkDeleteModalBtn", (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);
      const modal = bsModal("medium", {
        title: "Videoların toplu silinməsi",
        modalId: "bulkDeleteModal",
        backdrop: "none",
      });
      ajaxPost(
        "",
        { action: "bulk_delete_excel_modal", id: button.data("id") },
        modal,
      )
        .then((response) => {
          $(modal).modal("content", response.html);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors).join("<br>"),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on("submit", "#bulkDeleteExcelForm", (e) => {
      e.preventDefault();
      const form = $(e.target);
      const formData = new FormData(e.target);
      formData.append("action", "bulk_delete");
      form.loading({
        action: "show",
        loadingText: "gözləyin...",
      });
      ajax("", formData, form)
        .then((response) => {
          SuccessSwal.fire({
            icon: "success",
            text: `${response["deleted_count"]} video silindi`,
            timer: 4000,
          }).then(() => {
            form.closest(".modal").modal("hide");
            table.DataTable().ajax.reload();
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });

    $(".exportVideoData").on("click", (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);
      const data = form.serializeArray();
      data.push({ name: "action", value: "export" });
      button.attr("disabled", "disabled");
      ajaxPost("", data)
        .then((response) => {
          const data = `data:${response["content_type"]};base64,${response["base64"]}`;
          const link = document.createElement("a");
          link.href = data;
          link.download = String(response["file_name"]);
          link.click();
        })
        .finally(() => {
          button.removeAttr("disabled");
        });
    });

    $(document).on("click", ".bulkEditModalBtn", (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);
      const url = $(button).attr("href");
      const selectedVideos = $("input[name=videos]:checked");
      let selectedVideoIds = [];
      selectedVideos.each((index, element) => {
        selectedVideoIds.push($(element).val());
      });

      const modal = bsModal("medium", {
        title: "Toplu düzəliş",
        modalId: "bulkVideoEditModal",
        backdrop: "none",
      });
      ajaxPost(
        url,
        { action: "bulk_edit_modal", video_ids: selectedVideoIds.join(",") },
        modal,
      )
        .then((response) => {
          $(modal).modal("content", response.html);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors).join("<br>"),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on("submit", "#bulkVideoEditForm", (e) => {
      e.preventDefault();
      const form = $(e.target);
      const selectedVideos = $("input[name=videos]:checked");
      let selectedVideoIds = [];
      selectedVideos.each((index, element) => {
        selectedVideoIds.push($(element).val());
      });
      const data = {
        action: "bulk_edit",
        video_ids: selectedVideoIds.join(","),
        teacher: form.find("select[name=teacher]").val(),
      };
      ajaxPost(form.attr("action"), data, form)
        .then((response) => {
          SuccessSwal.fire({
            icon: "success",
            text: `${response["updated_count"]} video düzəliş edildi`,
            timer: 4000,
          }).then(() => {
            form.closest(".modal").modal("hide");
            table.DataTable().ajax.reload();
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });

    $(document).on("click", ".bulkDeleteVideo", (e) => {
      e.preventDefault();
      const selectedVideos = $("input[name=videos]:checked");
      let selectedVideoIds = [];
      selectedVideos.each((index, element) => {
        selectedVideoIds.push($(element).val());
      });
      const data = {
        action: "bulk_delete",
        video_ids: selectedVideoIds.join(","),
      };
      const url = "/gopanel/videos/ajax/";
      SwalPost(url, data, {
        text: "Seçilmiş videoları silmək istədiyinizdən əminsinizmi?",
        icon: "warning",
      }).then((response) => {
        SuccessSwal.fire({
          timer: 4000,
          text: `${response["deleted_count"]} video uğurla silindi`,
        }).then(() => {
          table.DataTable().ajax.reload();
        });
      });
    });

    // $(document).on("click", ".bulkReRender", (e) => {
    //   e.preventDefault();
    //   const selectedVideos = $("input[name=videos]:checked");
    //   let selectedVideoIds = [];
    //   selectedVideos.each((index, element) => {
    //     selectedVideoIds.push($(element).val());
    //   });
    //   const data = {
    //     action: "bulk_re_render",
    //     video_ids: selectedVideoIds.join(","),
    //   };
    //   const url = "/gopanel/videos/ajax/";
    //   SwalPost(url, data, {
    //     text: "Seçilmiş videoları təkrar render-ə göndərməyinizdən əminsinizmi?",
    //     icon: "warning",
    //   }).then((response) => {
    //     SuccessSwal.fire({
    //       timer: 4000,
    //       text: `${response["queue_count"]} video üçün təkrar render tapşırığı yaradıldı`,
    //     }).then(() => {
    //       window.location.href = String(response["redirect_url"]);
    //     });
    //   });
    // });

    $(document).on("click", ".bulkReRenderModalBtn", (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);
      const url = $(button).attr("href");
      const selectedVideos = $("input[name=videos]:checked");
      let selectedVideoIds = [];
      selectedVideos.each((index, element) => {
        selectedVideoIds.push($(element).val());
      });

      const modal = bsModal("medium", {
        title: "Toplu təkrar render",
        modalId: "bulkVideoReRenderModal",
        backdrop: "none",
      });
      ajaxPost(
        url,
        {
          action: "bulk_re_render_modal",
          video_ids: selectedVideoIds.join(","),
        },
        modal,
      )
        .then((response) => {
          $(modal).modal("content", response.html);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors).join("<br>"),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on("submit", "#bulkReRenderForm", (e) => {
      e.preventDefault();
      const form = $(e.target);
      const data = form.serializeArray();
      data.push({ name: "action", value: "bulk_re_render" });

      ajaxPost(form.attr("action"), data, form)
        .then(() => {
          SuccessSwal.fire({
            icon: "success",
            text: `Seçilmiş videolar təkrar render üçün fon tapşırığına göndərildi`,
            timer: 4000,
          }).then(() => {
            form.closest(".modal").modal("hide");
            table.DataTable().ajax.reload();
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });
  }

  if (body.hasClass("video-create")) {
    $("input[name=auto_thumbnail]").on("change", (e) => {
      const thumbnailField = $("input[name=thumbnail]");
      if (e.target.checked) {
        thumbnailField.removeAttr("required");
        thumbnailField.closest("div").hide();
      } else {
        thumbnailField.attr("required", "required");
        thumbnailField.closest("div").show();
      }
    });

    const videoCreateForm = $("#videoCreateForm");
    const videoCreateFormProgress = $("#videoCreateFormProgress");

    const dropzone = new Dropzone(".dropzone", {
      url: videoCreateForm.attr("action"),
      paramName: "content",
      maxFilesize: 2048, // MB
      uploadMultiple: false,
      autoProcessQueue: false,
      timeout: 30_000_000, // Milliseconds
      parallelUploads: 1,
      maxFiles: 1,
      addRemoveLinks: true,
      acceptedFiles: ".mp4,.mov,.mkv,.mpeg,.wmv,.wmv",
      dictDefaultMessage: `<i class="fas fa-cloud-upload-alt me-2"></i>Videonu buraya gətirin və ya <a href="#" class="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-75-hover">buradan seçin</a>`,
      dictFileTooBig: "Yüklənilən faylın həcmi qəbul olunandan böyükdur.",
      dictInvalidFileType: "Bu fayl formatı qəbul olunmur",
      dictCancelUpload: "Dayandır",
      dictRemoveFile: `<i class="far fa-trash-alt me-2"></i>Video sil`,
      dictRemoveFileConfirmation: "Faylı silməkdə əminsiniz?",
      dictFallbackMessage:
        "Sizin Brovseriniz köhnədir. Xahiş edirik Brovserinizi yeniləyin",
      dictMaxFilesExceeded: "Qəbul olunan maksimum fayl sayını keçdiniz",
      init: function () {
        this.on("sending", function (data, xhr, formData) {
          videoCreateForm.loading({
            loadingText: "video yüklənir...",
          });
          $(videoCreateForm).find(".alertWrapper").remove();
          $(videoCreateForm).find(".is-invalid").removeClass("is-invalid");
          $(videoCreateForm).find(".invalid-feedback").remove();
          $(videoCreateForm)
            .find("button[type=submit]")
            .attr("disabled", "disabled");
          const thumbnail = document.getElementById("thumbnail");
          $.each(videoCreateForm.serializeArray(), (key, el) => {
            formData.append(el.name, el.value);
          });
          if (thumbnail.files[0]) {
            formData.append("thumbnail", thumbnail.files[0]);
          }
        });
        this.on("error", function (file, errorMessage) {
          console.log("error", errorMessage);
          videoCreateForm.loading({ action: "hide" });

          if (file.xhr && errorMessage) {
            ajaxErrorAlert(errorMessage, videoCreateForm);
          }

          // if errorMessage type is an object, then convert to string
          if (typeof errorMessage === "object") {
            errorMessage = parceAjaxErrorResponse(errorMessage);
          }

          // string representation of errorMessage if too largely then cut
          if (typeof errorMessage === "string") {
            errorMessage = `${errorMessage.substring(0, 120)}...`;
          }

          file.previewElement.querySelector(
            "[data-dz-errormessage]",
          ).textContent = errorMessage;

          file.status = Dropzone.QUEUED;
        });
        this.on("success", function (file) {
          console.log("success", file);
          videoCreateForm.loading({ action: "hide" });
          SuccessSwal.fire({
            icon: "success",
            titleText: "Video uğurla yükləndi",
            text: `Video səhifəsinə yönlədirilirsiniz...`,
            timer: 3000,
          }).then(() => {
            window.location.href = JSON.parse(file.xhr.response)[
              "redirect_url"
            ];
          });
        });
        this.on("complete", function (file) {
          console.log("complete", file);
          videoCreateForm.loading({ action: "hide" });
          videoCreateFormProgress.hide();
          $(videoCreateForm).find("button[type=submit]").removeAttr("disabled");
        });
        this.on("addedfile", (file) => {
          const fileName = file.name.replace(/\.[^/.]+$/, "");
          const videoTitleInput = $("input[name=title]");
          if (!videoTitleInput.val()) {
            videoTitleInput.val(fileName);
          }
        });
        this.on("uploadprogress", function (file, progress, bytesSent) {
          const progressSrt = Math.round(progress) + "%";
          const sentMB = Math.round(bytesSent / 1024000);
          videoCreateFormProgress
            .show()
            .children()
            .attr("aria-valuenow", progressSrt)
            .attr("style", "width: " + progressSrt + "")
            .html(progressSrt + " (" + sentMB + " mb)");
        });
      },
    });

    videoCreateForm.on("submit", (e) => {
      e.preventDefault();

      if (dropzone.getQueuedFiles().length > 0) {
        dropzone.processQueue();
      } else {
        SuccessSwal.fire({
          icon: "warning",
          titleText: "Video seçilməyib",
          text: "Xahiş edirik video seçin",
        });
      }
    });
  }

  if (body.hasClass("video-bulk-create")) {
    const videoBulkCreateForm = $("#videoBulkCreateForm");
    const groupId = videoBulkCreateForm.find("input[name=group_id]").val();
    const filterUrl = `${videoBulkCreateForm.data(
      "filter-url",
    )}?group_id=${groupId}`;

    const dropzone = new Dropzone(".dropzone", {
      url: videoBulkCreateForm.attr("action"),
      paramName: "content",
      maxFilesize: 2048, // MB
      uploadMultiple: false,
      autoProcessQueue: false,
      timeout: 30_000_000, // Milliseconds
      parallelUploads: 2,
      maxFiles: 20,
      addRemoveLinks: true,
      acceptedFiles: ".mp4,.mov,.mkv,.mpeg,.wmv,.wmv",
      dictDefaultMessage: `<i class="fas fa-cloud-upload-alt me-2"></i>Videonu buraya gətirin və ya <a href="#" class="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-75-hover">buradan seçin</a>`,
      dictFileTooBig: "Yüklənilən faylın həcmi qəbul olunandan böyükdur.",
      dictInvalidFileType: "Bu fayl formatı qəbul olunmur",
      dictCancelUpload: "Dayandır",
      dictRemoveFile: `<i class="far fa-trash-alt me-2"></i>Video sil`,
      dictRemoveFileConfirmation: "Faylı silməkdə əminsiniz?",
      dictFallbackMessage:
        "Sizin Brovseriniz köhnədir. Xahiş edirik Brovserinizi yeniləyin",
      dictMaxFilesExceeded: "Qəbul olunan maksimum fayl sayını keçdiniz",
      init: function () {
        this.on("sending", function (data, xhr, formData) {
          $(videoBulkCreateForm).find(".alertWrapper").remove();
          $(videoBulkCreateForm).find(".is-invalid").removeClass("is-invalid");
          $(videoBulkCreateForm).find(".invalid-feedback").remove();
          $(videoBulkCreateForm)
            .find("button[type=submit]")
            .attr("disabled", "disabled");
          $.each(videoBulkCreateForm.serializeArray(), (key, el) => {
            formData.append(el.name, el.value);
          });
        });
        this.on("error", function (file, errorMessage) {
          console.log("error", file, errorMessage);

          // if errorMessage type is an object, then convert to string
          if (typeof errorMessage === "object") {
            errorMessage = parceAjaxErrorResponse(errorMessage);
          }

          // string representation of errorMessage if too largely then cut
          if (typeof errorMessage === "string") {
            errorMessage = `${errorMessage.substring(0, 120)}...`;
          }

          file.previewElement.querySelector(
            "[data-dz-errormessage]",
          ).textContent = errorMessage;
        });
        this.on("queuecomplete", function () {
          const allFiles = this.files;

          const hasErrors = allFiles.some(
            (file) => file.status === Dropzone.ERROR,
          );

          if (hasErrors) {
            ajaxErrorAlert(
              `Əməliyyat tamamlandı. ` +
                `Lakin bəzi videolar yüklənmədi. <br>` +
                `Yüklənmiş videolara <a class="text-danger-emphasis" href='${filterUrl}'>buradan</a> baxa bilərsiz`,
              videoBulkCreateForm,
            );
          } else {
            SuccessSwal.fire({
              icon: "success",
              titleText: "Videolar uğurla yükləndi",
              text: `Yüklənmiş videoların siyahısına yönlədirilirsiniz...`,
              timer: 3000,
            }).then(() => {
              window.location.href = filterUrl;
            });
          }

          $(videoBulkCreateForm)
            .find("button[type=submit]")
            .removeAttr("disabled");
        });
        this.on("success", function (file) {
          if (this.files.some((file) => file.status === Dropzone.QUEUED)) {
            this.processQueue();
          }

          $(videoBulkCreateForm)
            .find("button[type=submit]")
            .removeAttr("disabled");
        });
      },
    });

    videoBulkCreateForm.on("submit", (e) => {
      e.preventDefault();

      if (dropzone.getQueuedFiles().length > 0) {
        dropzone.processQueue();
      } else {
        SuccessSwal.fire({
          icon: "warning",
          titleText: "Video seçilməyib",
          text: "Xahiş edirik video seçin",
        });
      }
    });
  }

  if (body.hasClass("video-update")) {
    $("#videoUpdateForm").on("submit", (e) => {
      e.preventDefault();
      const form = $(e.target);
      const formData = new FormData(e.target);
      form.loading({ action: "show" });
      ajax("", formData, form)
        .then((response) => {
          SuccessSwal.fire({ timer: 1000 }).then(() => {
            window.location.href = String(response["redirect_url"]);
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });
  }

  if (
    body.hasClass("video-list") ||
    body.hasClass("video-update") ||
    body.hasClass("video-detail")
  ) {
    $(document).on("click", ".deleteVideo", (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);
      const url = `/gopanel/videos/${button.data("video-id")}/delete/`;
      SwalPost(
        url,
        {},
        {
          text: "Videonu silmək istədiyinizdən əminsinizmi?",
          icon: "warning",
        },
      ).then((response) => {
        SuccessSwal.fire({ timer: 1000 }).then(() => {
          window.location.href = String(response["redirect_url"]);
        });
      });
    });

    $(document).on("click", ".shareVideo", (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);

      const modal = bsModal("full", {
        title: "Videonun paylaşım linkləri",
        modalId: "shareVideoModal",
        backdrop: "none",
      });

      ajaxPost(
        button.attr("href"),
        { action: "share", id: button.data("video-id") },
        modal,
      )
        .then((response) => {
          $(modal).modal("content", response.html);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors).join("<br>"),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    // $(document).on("click", ".reRender", (e) => {
    //   e.preventDefault();
    //   const button = $(e.currentTarget);
    //   SwalPost(
    //     "/gopanel/videos/ajax/",
    //     { action: "re_render", id: button.data("video-id") },
    //     {
    //       text: "Videonu təkrar render etməyinizdən əminsinizmi?",
    //       icon: "warning",
    //     },
    //   ).then((response) => {
    //     SuccessSwal.fire({
    //       timer: 4000,
    //       text: String(response["message"]),
    //     }).then(() => {
    //       window.location.href = String(response["redirect_url"]);
    //     });
    //   });
    // });

    $(document).on("click", ".reRenderModalBtn", (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);
      const modal = bsModal("medium", {
        title: "Təkrar render",
        modalId: "reRenderModal",
        backdrop: "none",
      });
      ajaxPost("/gopanel/videos/ajax/", {
        action: "re_render_modal",
        id: button.data("video-id"),
      })
        .then((response) => {
          $(modal).modal("content", response.html);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors).join("<br>"),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on("submit", "#reRenderForm", (e) => {
      e.preventDefault();
      const form = $(e.target);
      const data = form.serializeArray();
      data.push({ name: "action", value: "re_render" });

      ajaxPost(form.attr("action"), data, form)
        .then(() => {
          SuccessSwal.fire({
            icon: "success",
            text: `Video render üçün fon tapşırığına göndərildi`,
            timer: 4000,
          }).then(() => {
            form.closest(".modal").modal("hide");
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });
  }

  if (body.hasClass("vimeo-migration")) {
    const table = $(".table");
    let form = $(".listFilterForm");

    table.DataTable({
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
      rowCallback: function (nRow, aData) {
        $(nRow).find("td:last-of-type").append(`
          <button data-id="${aData["id"]}" class="vimeoVideoMigrationModalBtn btn btn-sm btn-primary">
            Ətraflı
          </button>
          <button data-id="${aData["id"]}" class="vimeoVideoMigrationDelete btn btn-sm btn-danger">
            <i class="fas fa-trash-alt me-2"></i>Sil
          </button>
        `);
      },
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
      $(body).modal("hideAll");
    });

    $(document).on("click", ".vimeoVideoMigrationModalBtn", (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);
      const modal = bsModal("medium", {
        title: "Vimeo migrasiya statusu",
        modalId: "vimeoVideoMigrationModal",
        backdrop: "none",
      });
      ajaxPost("", { action: "migration_detail", id: button.data("id") }, modal)
        .then((response) => {
          $(modal).modal("content", response.html);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors).join("<br>"),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on("click", ".importFromExcelModalBtn", (e) => {
      e.preventDefault();
      const button = $(e.currentTarget);
      const modal = bsModal("medium", {
        title: "Excel-dən import",
        modalId: "importFromExcelModal",
        backdrop: "none",
      });
      ajaxPost(
        "",
        { action: "import_excel_modal", id: button.data("id") },
        modal,
      )
        .then((response) => {
          $(modal).modal("content", response.html);
        })
        .catch((errors) => {
          ErrorSwal.fire({
            html: parceAjaxErrorResponse(errors).join("<br>"),
          }).then(() => {
            $(modal).modal("hide");
          });
        });
    });

    $(document).on("submit", "#importFromExcelForm", (e) => {
      e.preventDefault();
      const form = $(e.target);
      const formData = new FormData(e.target);
      formData.append("action", "import_excel");
      form.loading({
        action: "show",
        loadingText: "idxal olunur...",
      });
      ajax(form.attr("action"), formData, form)
        .then((response) => {
          SuccessSwal.fire({
            icon: "success",
            titleText: "Excel uğurla idxal edildi",
            text: response["message"],
            timer: 10_000,
          }).then(() => {
            form.closest(".modal").modal("hide");
            table.DataTable().ajax.reload();
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });

    $(document).on("click", ".vimeoVideoMigrationDelete", (e) => {
      e.preventDefault();
      SwalPost(
        "",
        { id: $(e.currentTarget).data("id"), action: "delete" },
        {
          text: "Miqrasiyanı silmək istədiyinizdən əminsinizmi?",
          icon: "warning",
        },
      ).then((response) => {
        SuccessSwal.fire({ timer: 1000 }).then(() => {
          window.location.href = String(response["redirect_url"]);
        });
      });
    });

    $(document).on("click", ".deleteAllErrors", (e) => {
      e.preventDefault();
      SwalPost(
        "",
        { action: "delete_all_errors" },
        {
          text: "Bütün xətalı miqrasiyaları silmək istədiyinizdən əminsinizmi?",
          icon: "warning",
        },
      ).then((response) => {
        SuccessSwal.fire({
          text: `${response["deleted_count"]} xətalı miqrasiya silindi`,
          timer: 1000,
        }).then(() => {
          window.location.href = String(response["redirect_url"]);
        });
      });
    });
  }
});
